<template>
    <div class="draw">
        <div v-if="drawIconShow" class="draw_iconbtn" @click="drawDialog = true" title="抽奖icon">
            <div class="draw_time">{{ getIntervalTime(second) }}</div>
        </div>

        <!-- 抽奖弹窗 -->
        <div v-show="drawDialog" class="dialog" title="抽奖弹窗">
            <div class="draw_content">
                <p class="draw_content_timeout">
                    <img loading="lazy" src="../../assets/lives/cj_left.png" />
                    倒计时:<span id="drawTimer">{{ getIntervalTime(second) }}</span>
                    <img loading="lazy" src="../../assets/lives/cj_right.png" />
                </p>
                <img :src="drawDetail.img ? drawDetail.img : drawDefaultImg" alt="" class="draw_content_img" />
                <p class="draw_content_desc">{{ drawDetail.desc }}</p>
                <button v-if="!isJoinDraw" @click="closeDraw('drawDialog')" class="draw_content_btn">
                    参与抽奖
                </button>
                <button v-else class="draw_content_btn" style="background: rgb(153, 153, 153);;">
                    已参与
                </button>
                <img @click="closeDraw('drawDialog')" src="../../assets/lives/guan_ds.png" alt="" class="draw_closebtn">
            </div>
        </div>

        <!-- 兑奖弹窗 -->
        <div v-if="exchangeDialog" class="dialog">
            <template v-if="drawDate.openType == 0" title="无">
                <div class="draw_exchange">
                    <p style="font-weight: bold; font-size: 18px;">恭喜获得</p>
                    <p style="font-size: 16px;">{{ drawDetail.desc }}</p>
                    <img :src="drawDetail.img ? drawDetail.img : drawDefaultImg" alt="" class="draw_exchange_img"
                        style="width: 100px; height: 100px; margin-top: 45px;" />
                    <p @click="drawListDialog = true" class="p_pointer"
                        style="margin-top: 100px; color: rgb(251, 233, 205);">
                        中奖名单</p>
                    <img @click="closeDraw('exchangeDialog')" src="../../assets/lives/guan_ds.png" alt=""
                        class="draw_exchange_closeimg p_pointer ">
                </div>
            </template>

            <template v-if="drawDate.openType == 1" title="表单兑奖">
                <div class="draw_exchange">
                    <p style="font-weight: bold; font-size: 16px;">恭喜获得</p>
                    <p>{{ drawDetail.desc }}</p>
                    <img :src="drawDetail.img ? drawDetail.img : drawDefaultImg" alt="" class="draw_exchange_img" />
                    <p>请填写兑奖人姓名和联系方式</p>
                    <input v-model="submitInfo.name" type="text" placeholder="请输入姓名（必填）">
                    <input v-model="submitInfo.mobile" type="text" placeholder="请输入手机号（必填）">
                    <button @click="submitDrawList">提交</button>
                    <p @click="drawListDialog = true" class="p_pointer"
                        style="margin-top: 10px; color: rgb(251, 233, 205);">
                        中奖名单</p>
                    <img @click="closeDraw('exchangeDialog')" src="../../assets/lives/guan_ds.png" alt=""
                        class="draw_exchange_closeimg p_pointer ">
                </div>
            </template>

            <template v-if="drawDate.openType == 3" title="二维码兑奖">
                <div class="draw_exchange">
                    <p style="font-weight: bold; font-size: 18px;">恭喜获得</p>
                    <p style="font-size: 16px;">{{ drawDetail.desc }}</p>
                    <img :src="drawDetail.img ? drawDetail.img : drawDefaultImg" alt="" class="draw_exchange_img"
                        style="width: 100px; height: 100px; margin: 45px 0 30px 0;" />
                    <button @click="qrcodeDialog = true">去领取</button>
                    <p @click="drawListDialog = true" class="p_pointer"
                        style="margin-top: 10px; color: rgb(251, 233, 205);">
                        中奖名单</p>

                    <img @click="closeDraw('exchangeDialog')" src="../../assets/lives/guan_ds.png" alt=""
                        class="draw_exchange_closeimg p_pointer ">
                </div>
            </template>
        </div>

        <!-- 中奖名单弹窗 -->
        <div v-if="drawListDialog" class="dialog" style="z-index:1012;">
            <div class="draw_list">
                <div class="draw_list_name" @scroll="drawListScroll">
                    <span v-for="(item, index) in 150" :key="index" class="draw_list_nameitem">哈哈哈哈哈哈哈哈哈哈哈哈哈哈</span>
                </div>
                <img @click="closeDraw('drawListDialog')" src="../../assets/lives/guan_ds.png" alt=""
                    class="draw_exchange_closeimg p_pointer ">
            </div>
        </div>

        <!-- 未中奖弹窗 -->
        <div v-if="nodrawDialog" class="dialog">
            <div class="draw_nodraw">
                <p>就差一点运气</p>
                <button @click="drawListDialog = true">查看中奖名单</button>
                <img @click="closeDraw('nodrawDialog')" src="../../assets/lives/guan_ds.png" alt=""
                    class="draw_exchange_closeimg p_pointer ">
            </div>
        </div>

        <!-- 兑奖二维码弹窗 -->
        <div v-if="qrcodeDialog" class="dialog">
            <div class="draw_qrcode">
                <p>扫码添加客服领取</p>
                <img :src="drawDefaultImg" alt="" style="width: 100px; height: 100px; margin:20px auto 0 auto;">
                <img @click="closeDraw('qrcodeDialog')" src="../../assets/lives/guan_ds.png" alt=""
                    class="draw_qrcode_close p_pointer ">
            </div>
        </div>
    </div>
</template>

<script>
import { preTime } from "@/utils/util"
var drawInterval //抽奖倒计时

export default {
    name: "draw",
    // props: ['drawDate'],
    data() {
        return {
            drawDefaultImg: require('@/assets/lives/cj_fd.png'),
            drawDetail: {},        //抽奖详情
            isJoinDraw: false,    //是否参与抽奖
            drawDialog: false,   //抽奖弹窗
            exchangeDialog: false,  // 兑奖弹窗
            drawListDialog: false,  //中奖名单弹窗
            nodrawDialog: false,    //未中奖名单弹窗
            drawIconShow: false,    //抽奖icon
            qrcodeDialog: false,    //抽奖二维码弹窗
            second: 0,
            submitInfo: {
                name: '',
                mobile: '',
            },
            page: 1,                 //中奖名单页码
            count: 20,               //中奖名单单页数量
            total: 0,                //中奖名单总数      
            drawList: [],            //中奖名单列表
            antiShake: [],           //防抖
        }
    },

    mounted() {
        this.initDraw()
    },

    methods: {
        // 初始化处理抽奖信息
        initDraw() {
            var that = this
            clearInterval(drawInterval)
            if (that.drawDate.isOpen && that.drawDate.isOpen == 1) {
                setTimeout(() => {
                    that.checkPrizeUser()
                    that.getPrizeCache('refresh')
                }, Math.floor(Math.random() * (10000 - 1) + 1))
            } else {
                that.drawDetail = that.drawDate
                if (that.drawDate.timer > 0) {
                    that.drawDialog = true
                    that.second = that.drawDate.timer
                    drawInterval = setInterval(() => {
                        if (that.second <= 0) {
                            that.closeDraw()
                            clearInterval(drawInterval)
                        }
                        that.second--
                    }, 1000)
                }
            }
        },

        // 查看是否中奖
        checkPrizeUser() {
            var that = this
            let param = {
                account: localStorage.getItem('user_account'),
                drawId: that.drawDate.drawId,
                roomId: localStorage.getItem('room_id'),
            }
            that.$api.checkPrizeUser(param).then(res => {
                if (res.data.code == 200) {
                    var isHaveDraw = res.data.data.isPrize == 1 ? true : false
                    if (isHaveDraw) {
                        that.exchangeDialog = true
                        that.$api.getDraw(param.drawId).then(res => {
                            if (res.data.code == 200) {
                                that.drawDetail = res.data.data
                            }
                        })
                    } else {
                        that.nodrawDialog = true
                    }
                }
            }).catch(err => {
                that.$message.error("获取中奖信息失败")
            })
        },

        // 提交兑奖信息
        submitDrawList() {
            if (this.antiShake.indexOf(type) != -1) {
                this.$message.error("请不要重复点击")
                return;
            }
            this.antiShake.push(type)
            if (!this.submitInfo.name) {
                this.$message.error("姓名不能为空")
                return;
            } else if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.submitInfo.mobile)) {
                this.$message.error("请输入正确的手机号码")
                return;
            }
            let param = {
                drawId: this.drawDate.drawId,
                mobile: this.submitInfo.mobile,
                name: this.submitInfo.name,
                channelName: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').title : "",
                channelId: sessionStorage.getItem('channel_info') ? sessionStorage.getItem('channel_info').channel_id : "",
                submit: 1
            }
            this.$api.submitDrawList(param).then(res => {
                this.antiShake.splice(this.antiShake.indexOf(type), 1)
                if (res.data.code == 200) {
                    this.$message.success("提交成功")
                    this.drawListDialog = false
                }
            }).catch(err => {
                this.antiShake.splice(this.antiShake.indexOf(type), 1)
            })
        },

        // 获取中奖名单列表
        getPrizeCache(type) {
            if (type == 'refresh') {
                this.page = 1
                this.drawList = []
            } else {
                if (this.total && this.pageNo > Math.ceil(this.total / 20)) return;
            }
            let param = {
                drawId: this.drawDate.drawId,
                index: this.page,
                count: this.count
            }
            this.$api.getPrizeCache(param).then(res => {
                if (res.data.code == 200) {
                    this.drawList = this.drawList.concat(res.data.data)
                    this.total = res.data.total
                }
            })
            this.page++
        },

        // 中奖名单滚动
        drawListScroll(e) {
            var { clientHeight, scrollHeight, scrollTop } = e.target
            const distance = scrollHeight - scrollTop - clientHeight;
            if (distance < 50) {
                this.getPrizeCache()
            }
        },

        // 关闭福袋
        closeDraw(type) {
            this[type] = false
            if (type == 'drawDialog') {
                this.isJoinDraw = true
                this.drawIconShow = this.second > 0 ? true : false
            } else if(type != 'qrcodeDialog') {
                this.$emit('close')
            }
        },

        getIntervalTime(time) {
            return preTime(time)
        },
    },
}
</script>

<style lang="scss">
.p {
    &_pointer {
        cursor: pointer;
    }
}

.draw {
    position: absolute;
    top: 10px;

    &_iconbtn {
        width: 38px;
        height: 38px;
        text-align: center;
        margin-left: 10px;
        position: relative;
        background: url('../../assets/lives/cj_btn.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    &_time {
        display: block;
        position: absolute;
        bottom: -10px;
        left: -10px;
        background: rgba(0, 0, 0, 0.4);
        font-size: 20px;
        color: #fff;
        padding: 0 3px;
        text-align: center;
        transform: scale(0.5);
        border-radius: 5px;
    }

    &_content {
        width: 290px;
        overflow: visible;
        background: url('../../assets/lives/cj_bg.png') no-repeat;
        background-size: 100%;
        background-color: #fff;
        padding-bottom: 74px;
        position: relative;
        top: 10%;
        margin: auto;
        border-radius: 5px;

        &_timeout {
            text-align: center;
            padding-top: 100px;
            font-size: 16px;
            color: #983A00;
            font-weight: 500;

            &>img {
                width: 45px;
                height: 11px;
                margin: -5px 12px 0 12px;
            }
        }

        &_btn {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40px;
            background: linear-gradient(135deg, #F44502 0%, #FF8A1E 0%, #EA5400 100%);
            border-radius: 0px 0px 5px 5px;
            z-index: 1010;
            border: 0;
            outline: none;
            font-size: 15px;
            color: #fff;
        }

        &_img {
            width: 70px;
            height: 70px;
            margin: 24px auto 0 auto;
            // background: url('../../assets/lives/csm_bg.png') no-repeat;
            // background-size: contain;
            // background-position: center;
        }

        &_desc {
            padding-top: 16px;
            max-width: 80%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: center;
            margin: auto;
            color: #333333;
        }
    }

    &_closebtn {
        width: 32px;
        height: 32px;
        position: absolute;
        bottom: -65px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    &_exchange {
        width: 290px;
        height: 445px;
        background: url("../../assets/lives/cj_godraw.png") no-repeat;
        background-size: contain;
        color: rgb(255, 255, 255);
        text-align: center;
        margin: 10% auto 0 auto;
        color: rgb(126, 40, 13);
        font-size: 14px;
        padding: 80px 0 0 0;

        &>input {
            display: block;
            margin: 10px auto;
            width: 80%;
            height: 40px;
            line-height: 30px;
            font-size: 14px;
            border-radius: 20px;
            outline: none;
            border: 0px;
            background-color: rgb(247, 248, 250);
            text-align: center;
            color: rgb(102, 102, 102);
        }

        &>button {
            display: block;
            width: 60%;
            height: 30px;
            margin: 45px auto 0px;
            background-color: rgb(250, 233, 205);
            border-radius: 25px;
            font-size: 12px;
            line-height: 30px;
            color: rgb(137, 39, 19);
            border: none;
        }

        &_img {
            width: 50px;
            height: 50px;
            margin-bottom: 10px;
        }

        &_closeimg {
            width: 32px;
            height: 32px;
            margin-top: 30px;
        }

        &>p {
            margin-bottom: 10px;
        }
    }

    &_list {
        width: 290px;
        height: 433px;
        background: url("../../assets/lives/cj_zjmd.png") no-repeat;
        background-size: contain;
        text-align: center;
        position: relative;
        top: 20%;
        margin: auto;
        border-radius: 5px;
        box-sizing: border-box;
        padding-top: 140px;

        &_name {
            margin: 0 auto 40px auto;
            width: 70%;
            height: 250px;
            text-align: left;
            color: rgb(249, 66, 45);
            overflow-y: scroll;

            &::-webkit-scrollbar {
                display: none
            }

            &>span {
                display: inline-block;
                width: 30%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0 6px 10px 0;
            }
        }
    }

    &_nodraw {
        width: 290px;
        height: 433px;
        background: url("../../assets/lives/cj_nozj.png") no-repeat;
        background-size: contain;
        text-align: center;
        position: relative;
        top: 20%;
        margin: auto;
        border-radius: 5px;
        box-sizing: border-box;
        padding-top: 250px;
        color: white;
        font-size: 16px;

        &>button {
            display: block;
            width: 190px;
            height: 36px;
            margin: 20px auto 30px auto;
            background-color: rgb(255, 98, 88);
            border-radius: 5px;
            font-size: 14px;
            line-height: 36px;
            border: none;
            color: white;
        }
    }

    &_qrcode {
        width: 290px;
        text-align: center;
        position: relative;
        top: 20%;
        margin: auto;
        border-radius: 10px;
        font-size: 16px;
        background: white;
        padding: 10px 0 20px 0;
        color: rgb(0, 0, 0);

        &_close {
            width: 32px;
            height: 32px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            bottom: -50px;

        }
    }

}
</style>